<template>
    <div class="page-container">
        <div class="home-container">
            <div class="logo-container" :class="{ 'white-bg': showProductList }">
                <div class="logo-wrapper">
                    <img src="../assets/logo.png" alt="" class="logo">
                </div>
                <div class="nav-links">
                    <div class="nav-item" :class="{ 'dark-text': showProductList }" @click="$router.push('/')">首页</div>
                    <div class="nav-item product-nav" :class="{ 'active': showProductList }" @click="toggleProductList">
                        雾曼技术和产品</div>
                    <div class="nav-item" :class="{ 'dark-text': showProductList }" @click="$router.push('/Dynamic')">
                        雾曼动态
                    </div>
                    <div class="nav-item" :class="{ 'dark-text': showProductList }" @click="$router.push('/about')">关于雾曼
                    </div>
                    <div class="nav-item nav-item2" :class="{ 'dark-text': showProductList }"
                        @click="$router.push('/contact'), FisMobile()">联系雾曼</div>
                    <div class="nav-item" :class="{ 'dark-text': showProductList }"
                        @click="$router.push('/Cooperation')">
                        成为合伙人</div>
                </div>
                <div class="consult-button" @click="navigateToConsult">需求咨询</div>

                <div class="mobile-menu-btn" @click="showMobileMenu = !showMobileMenu">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

                <div class="mobile-menu" :class="{ 'show': showMobileMenu }">
                    <div class="mobile-menu-item" @click="$router.push('/')">首页</div>
                    <div class="mobile-menu-item" @click="$router.push('/Dynamic')">雾曼动态</div>
                    <div class="mobile-menu-item" @click="$router.push('/about')">关于雾曼</div>
                    <div class="mobile-menu-item" @click="$router.push('/contact')">联系雾曼</div>
                    <div class="mobile-menu-item" @click="$router.push('/cooperation')">成为合伙人</div>
                    <div class="mobile-menu-item highlight" @click="navigateToConsult">需求咨询</div>
                </div>
            </div>
            <product-list v-if="showProductList" :top="0" />
            <div class="info-container">
                <div class="page-title">联系我们</div>
            </div>
        </div>

        <div class="contact-info-section">
            <div class="contact-info-left">
                <div class="contact-card transparent-bg" v-for="(item, index) in contactList" :key="index" :class="{
                'selected': item === selectedCard
            }" @click="selectLocation(item)">
                    <div class="contact-card-content">
                        <div class="icon-wrapper">
                            <img src="../assets/contact/contact2.png" alt="">
                        </div>
                        <div class="contact-details">
                            <div class="contact-title">{{ item.title }}</div>
                            <div class="contact-address">{{ item.subTitle }}</div>
                            <div class="contact-phone">{{ item.summary }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="map-container">
                <div class="map-content" style="overflow: hidden;">
                    <ChinaMap :position="selectedPosition" />
                </div>
            </div>
        </div>

        <div class="consult-section">
            <ConsultSection :input-width="500" />
        </div>
        <!--<div class="Aichat">
            <ChatWidget :defaultOpen="isOpen" />
            <div class="Aitext" @click="openChat">AI小曼</div>
        </div>-->
        <Footer />
    </div>
</template>

<script>
import Footer from '@/components/Footer.vue'
import ConsultSection from '@/components/ConsultSection.vue'
import ProductList from '@/components/ProductList.vue'
import ChinaMap from '@/components/ChinaMap.vue';
import ChinaMap2 from '@/components/ChinaMap2.vue';

export default {
    name: 'Contact',
    components: {
        ConsultSection,
        Footer,
        ProductList,
        ChinaMap,
        ChinaMap2
    },
    data() {
        return {
            showMobileMenu: false,
            showProductList: false,
            contactList: [],
            selectedPosition: null,
            selectedCard: null
        }
    },
    created() {
        this.getContactList()
    },
    methods: {
        async getContactList() {
            try {
                const response = await this.$http.get('/cms/content/front-list', {
                    params: {
                        pageNum: 1,
                        pageSize: 10,
                        catalogId: '646399417831493'
                    }
                })
                if (response.code === 200) {
                    console.log('API返回数据：', response.data)
                    this.contactList = response.data.rows
                    if (this.contactList.length > 0) {
                        this.selectLocation(this.contactList[0])
                    }
                }
            } catch (error) {
                console.error('获取联系方式列表失败：', error)
            }
        },
        selectLocation(item) {
            this.selectedCard = item;
            if (item.tags && item.tags.length >= 2) {
                const longitude = Number(item.tags[0]);
                const latitude = Number(item.tags[1]);
                if (!isNaN(longitude) && !isNaN(latitude)) {
                    this.selectedPosition = [longitude, latitude];
                }
            }
        },
        toggleProductList() {
            this.showProductList = !this.showProductList;
        },
        navigateToConsult() {
            this.showMobileMenu = false;
            setTimeout(() => {
                window.scrollTo({
                    top: 1000,
                    behavior: 'smooth'
                });
            }, 500);
        },

        FisMobile() {
            this.showProductList = false;
        },
        openChat() {
            console.log(this.isOpen)
            this.isOpen = !this.isOpen
        }
    }
}
</script>


<style scoped>
.contact-card {
    margin: 0 0 15px 0;
    width: calc(519px - 54px);
    background: #F5F6F7;
    border-radius: 7px;
    padding: 27px 22px 27px 27px;
    transition: all 0.3s ease;
    cursor: pointer;
}

.contact-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.contact-card.selected {
    background: #F5F6F7;
    border: 1px solid #F5F6F7;
}

.contact-card.selected:hover {
    transform: none;
    box-shadow: none;
}

.transparent-bg {
    background: transparent;
}

.transparent-bg:hover {
    background: #F5F6F7;
}

.page-container {
    background: #F5F6F7;
}

.page-title {
    color: #FFFFFF;
    font-size: 52px;
    font-weight: 500;
    margin: 96px 0 0 213px;
}

.contact-info-section {
    width: 1346px;
    margin: -40px auto 0;
    height: 485px;
    background: #fff;
    border-radius: 15px;
    display: flex;
}

.contact-info-left {
    padding: 30px 23px 23px 30px;
    max-height: 422px;
    overflow-y: auto;
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
}

.contact-info-left::-webkit-scrollbar {
    display: none;
    /* Chrome, Safari and Opera */
}

.contact-card {
    margin: 0 0 15px 0;
    width: calc(519px - 54px);
    /* height: 112px; */
    background: #F5F6F7;
    border-radius: 7px;
    padding: 27px 22px 27px 27px;
    transition: all 0.3s ease;
    cursor: pointer;
}

.contact-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.transparent-bg {
    background: transparent;
}

.transparent-bg:hover {
    background: #F5F6F7;
}

.contact-card-content {
    display: flex;
}

.icon-wrapper {
    width: 14px;
    height: 20px;
}

.contact-details {
    padding: 0 0 0 16px;
}

.contact-title {
    line-height: 20px;
    font-size: 18px;
    font-weight: 400;
    color: #041214;
}

.contact-address,
.contact-phone {
    font-size: 12px;
    color: #041214;
    font-weight: 400;
    padding: 5px 0 0 0;
}

.map-container {
    padding: 30px 23px 23px 30px;
}

.map-content {
    width: 734px;
    height: 422px;
    background: #000;
}

.consult-section {
    background: #FFFFFF;
    border-radius: 15px;
    width: 1346px;
    margin: 60px auto;
}

@media screen and (max-width: 768px) {
    .page-title {
        font-size: 32px !important;
        margin: 50px 0 0 20px !important;
    }

    .contact-info-section {
        width: 100%;
        margin: -0px auto 0;
        height: auto;
        flex-direction: column;
    }

    .contact-info-left,
    .map-container {
        padding: 15px;
        width: 100%;
    }

    .contact-card {
        width: 100%;
        margin-bottom: 10px;
    }

    .map-content {
        width: 100%;
        height: 300px;
    }

    .consult-section {
        width: 100%;
        margin: 30px auto;
        padding: 15px;
    }
}

.home-container {
    width: 100%;
    height: 380px;
    background-color: #000;
    background-image: url("../assets/contact/contact1.png");
    background-size: cover;
    background-position: center;

}

.logo-container {
    width: 100%;
    height: 70px;
    background: rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(3px);
    padding: 0 55px;
    display: flex;
    align-items: center;
    position: relative;
}

.logo-wrapper {
    position: absolute;
}

.logo {
    width: 251px;
    height: 32px;
}

.nav-links {
    display: flex;
    color: #FFFFFF;
    font-size: 15px;
    font-weight: 600;
    font-style: normal;
    text-align: center;
    margin: auto;
    height: 68px;
    line-height: 70px;
    cursor: pointer;
}

.nav-item {
    padding: 0 20px;
}

.nav-item2 {
    border-bottom: 2px solid #FFFFFF;
}

.consult-button {
    background: #FFFFFF;
    border-radius: 17px;
    width: 96px;
    height: 32px;
    font-weight: 600;
    font-size: 14px;
    color: #0A2E43;
    line-height: 32px;
    text-align: center;
    position: absolute;
    right: 54px;
}

/* .info-container {
    width: 1120px;
    margin: auto;
    margin: 233px;
} */

.info-box {
    width: calc(367px - 13px - 13px);
    padding: 0 13px;
    height: 48px;
    background: #FFFFFF;
    border-radius: 8px;
    line-height: 48px;
}

.info-title {
    font-size: 20px;
    color: #041214;
    font-weight: 500;
    font-style: normal;
}

.info-subtitle {
    color: #041214;
    font-size: 16px;
    font-weight: 400;
    font-style: normal;
}

.info-text {
    font-weight: 500;
    font-size: 56px;
    color: #FFFFFF;
    text-align: left;
    font-style: normal;
    width: 1120px;
}

.contact-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
}

.contact-label {
    color: #FFFFFF;
    font-size: 14px;
    margin-left: 8px;
}

.contact-button {
    border: 1px solid #FFFFFF;
    border-radius: 8px;
    height: 48px;
    width: 158px;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 24px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.contact-button:hover {
    background: rgba(255, 255, 255, 0.1);
}

.contact-button img {
    width: 16px;
    height: 16px;
}

.contact-text,
.contact-icon {
    display: none;
}

@media screen and (max-width: 768px) {
    .home-container {
        height: 200px;
        position: relative;
        z-index: 10;
    }

    .logo-container {
        padding: 0 15px;
        height: 50px;
    }

    .logo {
        width: 150px;
        height: 20px;
    }

    .nav-links {
        display: none;
    }

    .consult-button {
        display: none;
    }

    .info-container div {
        font-size: 32px !important;
        margin: 50px 0 0 20px !important;
    }

    /* 联系信息区域适配 */
    div[style*="width: 1346px"] {
        width: 100% !important;
        margin: -20px auto 0 !important;
        height: auto !important;
        flex-direction: column;
    }

    div[style*="padding: 30px 23px 23px 30px"] {
        padding: 15px !important;
        width: 100% !important;
    }

    div[style*="width: calc(519px - 54px)"] {
        width: 100% !important;
        margin-bottom: 10px !important;
    }

    /* 地图区域适配 */
    div[style*="width: 734px"] {
        width: 100% !important;
        height: 300px !important;
    }

    /* 咨询区域适配 */
    div[style*="width: 1346px;margin: 60px auto"] {
        width: 100% !important;
        margin: 30px auto !important;
        padding: 15px;
    }
}

.mobile-menu-btn {
    display: none;
}

@media screen and (max-width: 768px) {
    .mobile-menu-btn {
        display: block;
        position: absolute;
        right: 15px;
        width: 30px;
        height: 25px;
        cursor: pointer;
        z-index: 1000;
    }

    .mobile-menu-btn span {
        display: block;
        width: 100%;
        height: 2px;
        background-color: #fff;
        margin: 6px 0;
        transition: 0.3s;
    }

    .mobile-menu {
        display: none;
        position: fixed;
        top: 50px;
        left: 0;
        width: 100%;
        background: rgba(0, 0, 0, 0.9);
        padding: 20px 0;
        z-index: 999;
    }

    .mobile-menu.show {
        display: block;
    }

    .mobile-menu-item {
        color: #fff;
        padding: 15px 20px;
        font-size: 16px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }

    .mobile-menu-item.highlight {
        background: #FFFFFF;
        color: #0A2E43;
        margin: 10px 20px;
        border-radius: 17px;
        height: 40px;
        line-height: 40px;
        padding: 0;
    }
}

/* 当菜单打开时的汉堡按钮动画 */
.mobile-menu-btn.active span:nth-child(1) {
    transform: rotate(45deg) translate(5px, 5px);
}

.mobile-menu-btn.active span:nth-child(2) {
    opacity: 0;
}

.mobile-menu-btn.active span:nth-child(3) {
    transform: rotate(-45deg) translate(7px, -7px);
}

/* 默认隐藏移动端菜单 */
.mobile-menu {
    display: none;
}

/* 修改媒体查询中的mobile-menu相关样式 */
@media screen and (max-width: 768px) {
    /* ... 其他移动端样式保持不变 ... */

    .mobile-menu {
        display: none;
        /* 默认仍然是隐藏的 */
        position: fixed;
        top: 50px;
        left: 0;
        width: 100%;
        background: rgba(0, 0, 0, 0.9);
        padding: 20px 0;
        z-index: 999;
        height: calc(100vh - 50px);
    }

    .mobile-menu.show {
        display: block;
        /* 只有在添加show类时才显示 */
    }

    .mobile-menu-item {
        color: #fff;
        padding: 15px 20px;
        font-size: 16px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }

    .mobile-menu-item.highlight {
        color: #0A2E43;
        background: #fff;
        margin: 10px 15px;
        border-radius: 17px;
        text-align: center;
    }
}

.logo-container.white-bg {
    background: #FFFFFF;
}

.nav-item.dark-text {
    color: #0A2E43;
}

.product-nav.active {
    color: #FF0000;
    border-bottom: 2px solid #FF0000;
}

.contact-list {
    padding: 20px;
}

.contact-item {
    margin-bottom: 20px;
    padding: 15px;
    border: 1px solid #eee;
    border-radius: 4px;
}

.contact-item h3 {
    margin-bottom: 10px;
    color: #333;
}

.contact-item p {
    color: #666;
    line-height: 1.5;
}
</style>